import i from"styled-components";import{theme as e}from"../../../../../../theme.js";const t=i.div`
  display: flex;
  flex-direction: column;
  gap: ${e.spacing*2}px;
  .header {
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    gap: ${e.spacing*4}px;
    align-items: center;
    .hub {
      display: grid;
      grid-template-columns: 40px 1fr;
      gap: ${e.spacing}px;
      align-items: center;
    }
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: ${e.spacing*2};
    margin-left: 74px;
  }
`,r=i.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${e.colors.primary[300]};
  > svg {
    width: 24px;
    height: 24px;
    > g,
    path {
      fill: ${e.colors.shades[0]};
    }
  }
  > img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 50%;
  }
`;export{t as Container,r as HubAvatar};
